interface RandomIconProps {
  size?: number;
  className?: string;
}

const RandomIcon: React.FC<RandomIconProps> = ({ size = 16, className }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ display: 'inline-block', verticalAlign: 'middle' }}
    aria-hidden="true"
  >
    {/* Top-right L-shaped arrowhead */}
    <polyline points="10.7,2 14,2 14,5.3" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" fill="none" />
    {/* Long diagonal: bottom-left → top-right (this arrow's shaft) */}
    <line x1="2.7" y1="13.3" x2="14" y2="2" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
    {/* Bottom-right L-shaped arrowhead */}
    <polyline points="14,10.7 14,14 10.7,14" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" fill="none" />
    {/* Second arrow's shaft, broken in the middle to suggest crossing under the first */}
    <line x1="2.7" y1="2.7" x2="6" y2="6" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
    <line x1="10" y1="10" x2="14" y2="14" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default RandomIcon;
